import angular from 'angular';

const moduleName = 'recaps.filters';

let module = angular.module(moduleName, []);

module.filter('ucfirst', function() {
  return function(input) {
    if (input && input.charAt !== undefined) {
      return input.charAt(0).toUpperCase() + input.slice(1);
    } else {
      return input;
    }
  };
});

module.filter('trustAsHtml', $sce => {
  return html => {
    return $sce.trustAsHtml(html);
  }
});

module.filter('sanitizeHtml', ($sce, $sanitize) => {
  const looksLikeHtml = value => /<\s*\/?\s*[a-z][\s\S]*>/i.test(value);

  return html => {
    const raw = html || '';
    let sanitized = $sanitize(raw);

    // Preserve line breaks for plain-text inputs (previously handled by `nl2br`).
    if (!looksLikeHtml(raw)) {
      sanitized = sanitized.replace(/(\r\n|\r|\n)/g, '<br>');
    }

    return $sce.trustAsHtml(sanitized);
  };
});

module.filter('nl2br', ($sce, $sanitize) => {
  // Originally from https://github.com/goodeggs/angular-nl2br
  // Updated with logic from https://github.com/philsch/angular-nl2br/blob/8aa140f6815c3b6f052c98d436f54e9631ce2134/angular-nl2br.js
  return input => {
    let output = input || '';
    output = output
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
    ;
    output = $sanitize(output);
    output = output.replace(/(&#10;&#13;|&#13;&#10;|&#10;|&#13;)/g, '<br>');
    output = $sce.trustAsHtml(output);
    return output;
  };
});

export default module;
